import React from 'react';
import { compose } from 'redux';
import { Flex } from '../../../components/Container/Flex';
import { Colors } from '../../../utils/style/colors';
import { useTranslation } from 'react-i18next';
import TextButton from '../../../components/Controls/TextButton';
import Button from '../../../components/Controls/Button';
import { SaveIcon } from '../../../utils/icons';


export default compose(

)(({ disabled, onCancel, onAccept, children }) => {
  const { t } = useTranslation();

  return (
    <Flex col>
      <div>
        {children}
      </div>
      <Flex col>
        <Button
          disabled={disabled}
          color={Colors.success}
          size="small"
          startIcon={<SaveIcon/>}
          onClick={onAccept}
          style={{ marginTop: 10, marginBottom: 5 }}>
          {t('save')}
        </Button>
        <TextButton onClick={onCancel}>
          {t('cancel')}
        </TextButton>
      </Flex>

    </Flex>
  );

});